import React from 'react';
import PropTypes from 'prop-types';
import logo from 'assets/svg/treadie-logo-4.svg';
import { Link } from 'react-router-dom';
import { FooterList } from 'components';
import { Drawer } from './drawer';

export class GuestLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      drawer: false
    };

    this.toggleDrawer = this.toggleDrawer.bind(this);
  }

  componentDidMount = () => {
    this.stickyListener = window.addEventListener('scroll', this.stickyNav);
  };

  stickyNav() {
    const topBar = document.querySelector('.top-bar');

    const barOffset = 40;
    const windowOffset = window.pageYOffset;

    if (topBar) {
      if (windowOffset > barOffset) {
        topBar.classList.add('sticky');
      } else {
        topBar.classList.remove('sticky');
      }
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.stickyListener);
  };

  toggleDrawer = () => {
    const { drawer } = this.state;
    this.setState({ drawer: !drawer });
  };

  render() {
    return (
      <div className="sb-wrapper">
        <header className={'site-header main'}>
          <div className={'top-bar main'}>
            <div className="row">
              <div className="medium-12 columns">
                <Link to="/" className="site-home top-bar-title">
                  <div className="">
                    <img src={logo} alt="" />
                    <strong className="" style={{ marginLeft: '10px' }}>
                      Treadie
                    </strong>
                  </div>
                </Link>

                <div className="top-bar-right">
                  <ul className="menu">
                    <li className="njoin">
                      {/* show this for landing */}
                      {this.props.static ? (
                        <a
                          href="mailto:info@treadie.com"
                          className="button button__join"
                        >
                          How
                          <span className="button__join__below">
                            can we help?
                          </span>
                        </a>
                      ) : this.props.loggedIn ? (
                        <div
                          onClick={this.toggleDrawer}
                          className="wrapper__header__avatar active"
                        >
                          <img src="https://picsum.photos/200" alt="Avatar" />
                        </div>
                      ) : (
                        <Link to="/login" className="button button__join">
                          Join
                          <span className="button__join__below">Or Login</span>
                        </Link>
                      )}
                      {/* show this for login, signup, privacy & terms */}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <Drawer active={this.state.drawer} />
        </header>

        {this.props.children}

        {this.props.footer ? (
          <footer className="footer">
            <div className="row">
              <div className="medium-12 columns">
                <div className="menu-centered">
                  <FooterList />
                </div>
              </div>
            </div>
          </footer>
        ) : null}
      </div>
    );
  }
}

GuestLayout.propTypes = {
  footer: PropTypes.bool,
  siteHeaderClass: PropTypes.string,
  topBarClass: PropTypes.string,
  static: PropTypes.bool,
  loggedIn: PropTypes.bool,
  children: PropTypes.node
};

GuestLayout.defaultProps = {
  footer: true
};
